import '@lottiefiles/lottie-player';
import { create } from '@lottiefiles/lottie-interactivity';

export default class LottieAnimations {
	static init(){
		const animations = document.querySelectorAll('.c-animation');
		animations.forEach(animation => new LottieAnimations(animation));
	}

	constructor(animation){

    	create({
			mode: 'scroll',
			player: '#messages',
			actions: [
				{
					visibility:[0, 1.0],
					type: 'seek',
					frames: [0, 150],
				},
			],
		});

		create({
			mode: 'scroll',
			player: '#arrow1',
			actions: [
				{
					visibility: [0.20, 1.0],
					type: 'play',
				},
			],
		});

		create({
			mode: 'scroll',
			player: '#circle',
			actions: [
				{
					visibility: [0.20, 1.0],
					type: 'play',
				},
			],
		});

	}
}
